import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { select, Store } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';

import * as calendarConfigurationActions from './calendar-configuration.actions';
import { calendarConfigurationQuery } from './calendar-configuration.selectors';
import { UserConfigurationPartialState } from '..';
import {
  saveUserConfiguration,
  updateViaCalendarConfiguration
} from '../user-configuration.actions';
import { userConfigurationQuery } from '../user-configuration.selectors';
import { USER_CONFIGURATION_MODULE_KEY } from '../../+state/user-configuration.declarations';
import { CalendarConfigurationDialogComponent } from '../../calendar-configuration-dialog/calendar-configuration-dialog.component';

@Injectable()
export class CalendarConfigurationEffects {
  private readonly userConfigurationState$ = this.store$.pipe(
    select(userConfigurationQuery.getUserConfigurationState)
  );

  private readonly calendarConfigurationState$ = this.store$.pipe(
    select(calendarConfigurationQuery.getCalendarConfigurationState)
  );

  /** init */
  initFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarConfigurationActions.initFeature),
      withLatestFrom(this.userConfigurationState$),
      map(([_, state]) =>
        calendarConfigurationActions.featureInitSuccess({
          calendarConfiguration: state.calendarConfiguration
        })
      ),
      catchError(() => of(calendarConfigurationActions.featureInitError()))
    )
  );

  /** dialog */
  cancelChanges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarConfigurationActions.cancelChanges),
      map(() => calendarConfigurationActions.clearState())
    )
  );

  confirmChanges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarConfigurationActions.confirmChanges),
      withLatestFrom(this.calendarConfigurationState$),
      concatMap(([_, state]) => [
        updateViaCalendarConfiguration({
          calendarConfiguration: state.calendarConfigurationForm.value
        }),
        saveUserConfiguration(),
        calendarConfigurationActions.clearState()
      ])
    )
  );

  openCalendarConfigurationDialog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarConfigurationActions.openCalendarConfigurationDialog),
      withLatestFrom(this.userConfigurationState$),
      map(([_, state]) => {
        this.dialog.open(CalendarConfigurationDialogComponent, {
          panelClass: 'sd-mat-dialog-container',
          width: '80%',
          maxHeight: '90%',
          autoFocus: false,
          disableClose: true
        });
        return calendarConfigurationActions.featureInitSuccess({
          calendarConfiguration: state.calendarConfiguration
        });
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<{
      [USER_CONFIGURATION_MODULE_KEY]: UserConfigurationPartialState;
    }>,
    private readonly dialog: MatDialog
  ) {}
}
